import { apiV2 } from '../axios';

export const getSchoolInfo = async (schoolId) => {
	return await apiV2.get(`/school?schoolIds=${schoolId}`);
};

export const getGoogleSchoolInfo = async (placeId) => {
	return await apiV2.get(`/school?googlePlaceId=${placeId}`);
};
